import { render, staticRenderFns } from "./UnitPrices.vue?vue&type=template&id=b165c084&scoped=true&"
import script from "./UnitPrices.vue?vue&type=script&lang=js&"
export * from "./UnitPrices.vue?vue&type=script&lang=js&"
import style0 from "./UnitPrices.vue?vue&type=style&index=0&id=b165c084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b165c084",
  null
  
)

export default component.exports